// GEDEON: Sticky Add to Cart - Mobile
(function () {
  'use strict';

  if (window.matchMedia('(min-width: 750px)').matches) return;

  function getStickyImageSrc(productImage) {
    if (!productImage) return '';

    var src = productImage.currentSrc || productImage.src || '';
    if (!src) return '';

    if (src.indexOf('width=') !== -1) {
      return src.replace(/([?&]width=)\d+/i, '$1160');
    }

    return src + (src.indexOf('?') === -1 ? '?width=160' : '&width=160');
  }

  function initStickyATC() {
    var productForm = document.querySelector('.product-form__submit')
      || document.querySelector('[name="add"]')
      || document.querySelector('.shopify-payment-button');
    if (!productForm || document.querySelector('.sticky-atc')) return;

    var productTitle = document.querySelector('.product__title') || document.querySelector('h1');
    var productPrice = document.querySelector('.price__regular .price-item--regular')
      || document.querySelector('.price-item--regular');
    var productImage = document.querySelector('.product__media img')
      || document.querySelector('.product-media-container img');
    var stickyImageSrc = getStickyImageSrc(productImage);

    var sticky = document.createElement('div');
    sticky.className = 'sticky-atc';
    sticky.setAttribute('aria-hidden', 'true');
    sticky.innerHTML = '\
      <div class="sticky-atc__product-info">\
        ' + (stickyImageSrc ? '<img src="' + stickyImageSrc + '" alt="" loading="lazy" fetchpriority="low" decoding="async">' : '') + '\
        <div>\
          <div class="sticky-atc__title">' + (productTitle ? productTitle.textContent.trim() : '') + '</div>\
          <div class="sticky-atc__price">' + (productPrice ? productPrice.textContent.trim() : '') + '</div>\
        </div>\
      </div>\
      <button class="sticky-atc__btn button button--primary" type="button" id="sticky-atc-btn">\
        Dodaj do koszyka\
      </button>\
    ';
    document.body.appendChild(sticky);

    var stickyBtn = sticky.querySelector('#sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var originalBtn = document.querySelector('.product-form__submit')
          || document.querySelector('[name="add"]');
        if (originalBtn) originalBtn.click();
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          sticky.classList.add('is-visible');
          sticky.setAttribute('aria-hidden', 'false');
        } else {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });

    observer.observe(productForm);
  }

  function scheduleStickyATC() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(initStickyATC, { timeout: 1200 });
      return;
    }
    window.setTimeout(initStickyATC, 350);
  }

  if (document.readyState === 'complete') {
    scheduleStickyATC();
    return;
  }

  window.addEventListener('load', scheduleStickyATC, { once: true });
  if (document.readyState === 'interactive') {
    scheduleStickyATC();
  }
})();
